<template>
  <div class="motor-display" :class="device">
      <span class="title">
        {{ $t('motor.display.specs') }}
      </span>
    <div class="motor-image-container" :class="device">
      <MotorImages/>
    </div>
    <button class="download-pdf d-flex align-items-center" @click="downloadPdf" :class="device">
      <img :src="getImage('hose/Pdf-file.svg')">
      <span class="mt-1 ml-2">{{ $t('motor.display.downloadPdf') }}</span>
    </button>
    <div class="alert-danger error px-1" v-if="error">
      <small>{{ error }}</small>
    </div>
    <div class="calculation-menu-container" :class="device">
      <CalculationsMenu/>
    </div>
    <div class="motor-info-menu-container" :class="device">
      <MotorInfoMenu/>
    </div>
  </div>
</template>

<script>
import CalculationsMenu from '@/components/motor/CalculationsMenu';
import MotorInfoMenu from '@/components/motor/MotorInfoMenu';
import {mapActions, mapGetters, mapState} from 'vuex';
import MotorImages from '@/components/motor/MotorImages';
import FileDownload from 'js-file-download';
import {AxiosDefault} from '@/mixins/AxiosWrapperMixin';
import Swal from "sweetalert2";

export default {
  name: 'MotorDisplay',
  components: {
    MotorImages,
    MotorInfoMenu,
    CalculationsMenu,
  },
  data() {
    return {
      error: null,
    };
  },

  computed: {
    ...mapState({
      magentoLoggedIn: state => state.preference.magentoLoggedIn,
      selectedMotor: state => state.build.motorConfig.preferences.selectedMotor,
    }),
    ...mapGetters({
      isMagento: 'preference/isMagento',
      device: 'getDevice',
      isLoggedIn: 'auth/isLoggedIn',
    }),
  },

  methods: {
    ...mapActions({
      redirectToLoginUrl: 'auth/redirectToLoginUrl',
    }),
    async downloadPdf() {
      this.error = null;
      if (!this.selectedMotor) {
        this.error = 'Selecteer eerst een motor';
        return;
      }

      const buildId = await this.$store.dispatch('build/motorConfig/getBuildId');
      this.$store.dispatch('share/open', {
        configurator: 'motor',
        uid: buildId,
        trigger: 'download-schema'
      });
    },
  },
};
</script>

<style scoped lang="scss">
.motor-display {
  grid-row-start: 1;
  grid-row-end: 2;
  grid-column-start: 2;
  grid-column-end: 3;
  background-color: #FFFFFF;
  padding: 16px 22px;
  display: grid;
  border-right: 3px solid #F0F0F0;
  border-bottom: 3px solid #F0F0F0;
  grid-template-columns: repeat(13, auto);
  grid-template-rows: repeat(7, auto);
  position: relative;

  &.mobile {
    grid-column-start: 1;
    grid-template-columns: repeat(3, auto);
    grid-template-rows: repeat(9, auto);

    .title {
      white-space: nowrap;
      padding: 10px 0;
      grid-column-start: 1;
      grid-column-end: 4;
      margin: 0 auto;
    }
  }
}

.motor-image-container {
  grid-row-start: 2;
  grid-row-end: 7;
  grid-column-start: 1;
  grid-column-end: 10;
  max-width: 800px;

  &.mobile {
    grid-row-start: 9;
    grid-row-end: 13;
  }
}

.download-pdf {
  grid-row-start: 7;
  grid-row-end: 8;
  border: none;
  background-color: transparent;
  outline: none;

  &.mobile {
    padding-top: 10px;
    grid-row-start: 8;
    grid-row-end: 9;
    grid-column-start: 1;
    grid-column-end: 4;
    margin: 0 auto;
  }
}

.error {
  grid-column-start: 1;
  grid-column-end: 4;
  margin-top: 4px;

  @media only screen and (min-width: 768px) {
    grid-row-start: 8;
    grid-row-end: 9;
  }
}

.calculation-menu-container {
  grid-row-start: 1;
  grid-row-end: 3;
  grid-column-start: 9;
  grid-column-end: 14;
  width: 100%;

  &.mobile {
    grid-row-start: 2;
    grid-row-end: 4;
    grid-column-start: 1;
    grid-column-end: 4;
  }
}

.motor-info-menu-container {
  grid-row-start: 4;
  grid-row-end: 8;
  grid-column-start: 9;
  grid-column-end: 14;

  &.mobile {
    grid-column-start: 1;
    grid-column-end: 4;
  }
}
</style>
